<!-- Top Bar -->
<mat-toolbar color="primary" class="top-toolbar">
  <button mat-icon-button (click)="sidenav.toggle()">
    <mat-icon>menu</mat-icon>
  </button>
  <a class="gradient-blue soft-3d" [routerLink]="['']">簽核流程系統</a>

  <span class="spacer"></span>

  @if (display) {
    <button
      mat-button
      [routerLink]="['/', 'forms-flow', 'transfer', 'ut', transferUtCod, 'type', 'transfer']"
    >
      <mat-icon>file_upload</mat-icon> 移文處理
    </button>
  }
  <button mat-button [routerLink]="['/', 'forms-flow', 'custom', 'uploadCustomForm']">
    <mat-icon>file_upload</mat-icon> 自訂表單
  </button>
  <button mat-button [routerLink]="['/', 'forms-flow', 'query']">
    <mat-icon>search</mat-icon> 查詢表單
  </button>
  <button mat-button [routerLink]="['/', 'personal-lexicon']">
    <mat-icon>library_books</mat-icon> 設定常用詞庫
  </button>
  <!-- <button mat-button href="https://nccumisdoc.nccu.edu.tw/forms-flow/" target="_blank">
    <mat-icon>help_outline</mat-icon> 線上說明
  </button> -->
</mat-toolbar>

<mat-sidenav-container class="dashboard-container">
  <!-- 左側 Sidebar -->
  <mat-sidenav
    #sidenav
    [mode]="isMobile ? 'over' : 'side'"
    [opened]="!isMobile"
    class="sidebar"
    (backdropClick)="sidenav.close()"
  >
    <div class="sidebar-wrapper">
      <!-- User Info -->
      <div class="cc-user-name">
        @if (staffData) {
          <h3>
            <mat-icon>person</mat-icon>
            {{ staffData.StaNam }}
          </h3>
        }
        <button mat-button color="warn" (click)="signOut()">
          <mat-icon>logout</mat-icon> 登出
        </button>
      </div>

      <!-- Menu -->
      <mat-nav-list>
        @for (formSummary of formSummaries; track $index) {
          <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
              <mat-panel-title>
                {{ formSummary.UtNam }} {{ formSummary.StaNam }} 表單資訊
              </mat-panel-title>
              @if (formSummary?.IsAgent) {
                <span>(代理)</span>
              }
            </mat-expansion-panel-header>

            <mat-nav-list>
              <a
                mat-list-item
                [routerLink]="[
                  '/',
                  'forms-flow',
                  'ut',
                  formSummary.UtCod,
                  'sta',
                  formSummary.StaNum,
                  'type',
                  FormType[FormType.Inprogress],
                ]"
              >
                <mat-icon>edit</mat-icon>
                待處理表單
                <span class="badge bg-red">{{ formSummary.InprogressCount }}</span>
              </a>
              <a
                mat-list-item
                [routerLink]="[
                  '/',
                  'forms-flow',
                  'ut',
                  formSummary.UtCod,
                  'sta',
                  formSummary.StaNum,
                  'type',
                  FormType[FormType.Submitted],
                ]"
              >
                <mat-icon>how_to_vote</mat-icon>
                已送未收
                <span class="badge bg-green">{{ formSummary.SubmittedCount }}</span>
              </a>
              <a
                mat-list-item
                [routerLink]="[
                  '/',
                  'forms-flow',
                  'ut',
                  formSummary.UtCod,
                  'sta',
                  formSummary.StaNum,
                  'type',
                  FormType[FormType.NotDone],
                ]"
              >
                <mat-icon>restore</mat-icon>
                承辦未完成
                <span class="badge bg-blue">{{ formSummary.NotDoneCount }}</span>
              </a>
              <a
                mat-list-item
                [routerLink]="[
                  '/',
                  'forms-flow',
                  'ut',
                  formSummary.UtCod,
                  'sta',
                  formSummary.StaNum,
                  'type',
                  FormType[FormType.FormTrace],
                ]"
              >
                <mat-icon>track_changes</mat-icon>
                追蹤清單
                <span class="badge bg-blue">{{ formSummary.FormTraceCount }}</span>
              </a>
            </mat-nav-list>
          </mat-expansion-panel>
        }

        @for (dispatchRole of dispatchFormSummaries; track $index) {
          <a
            mat-list-item
            [routerLink]="['/', 'unit-manager', 'to-dispatch-forms', 'ut', dispatchRole.UtCod]"
          >
            <mat-icon>desktop_windows</mat-icon>
            {{ dispatchRole.UtNam }} 單位登記桌
            @if (dispatchRole.IsAgent) {
              <span>(代理)</span>
            }
            <span class="badge bg-deep-purple">{{ dispatchRole.InprogressCount }}</span>
          </a>
        }
      </mat-nav-list>

      <!-- Footer -->
      <div class="legal">
        @if (ip) {
          <p style="font-size: 1em; color: #888">{{ ip }}</p>
        }
        <p>如對系統有任何問題，請電(02)29387599 或 校內分機：67599</p>
      </div>
    </div>
  </mat-sidenav>

  <!-- 主內容區 -->
  <mat-sidenav-content class="main-content">
    <div class="content-wrapper">
      <!-- <router-outlet (deactivate)="onDeactivate()"></router-outlet> -->
      <router-outlet (activate)="onActivate($event)" (deactivate)="onDeactivate()"></router-outlet>
    </div>
  </mat-sidenav-content>
</mat-sidenav-container>
